import React, { FunctionComponent } from 'react';

import { CTA } from '@gojob/cms';
import Cta from '@gojob/ui-bits/Cta';
import Link from '../Link';

export interface ButtonProps extends CTA {
  href?: string;
  onClick?: () => void;
  className?: string;
}

const Button: FunctionComponent<ButtonProps> = (props) => {
  const { variant = 'primary', internalRef, href, className, children, id, onClick, icon } = props;
  const to = internalRef?.slug?.current;

  return (
    <Cta
      id={id}
      as={Link}
      variant={variant}
      href={href}
      to={to}
      icon={icon?.type}
      onClick={onClick}
      className={className}
    >
      {children}
    </Cta>
  );
};

export default Button;
